import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  EstablishmentContractResponse,
  EstablishmentContractType,
} from '@/features/establishments/types/establishmentContract.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UseEstablishmentContractProps = {
  id: string
}

type UseEstablishmentContractType = (
  props: UseEstablishmentContractProps,
) => UseQueryResult<EstablishmentContractType, unknown>

export const useEstablishmentContract: UseEstablishmentContractType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EstablishmentContractResponse, unknown, EstablishmentContractType>({
    queryKey: ['establishmentContract', id],
    queryFn: () => {
      return privateAxios.get(`/establishment/contracts/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
